import React from 'react';
import { Alert } from 'antd';

/*
Error Boundaries must be class components - this is one of the few remaining cases in React where class components 
are still required. There are currently no Hook equivalents for componentDidCatch and getDerivedStateFromError.
*/

class CaseErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Case rendering error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Alert
          message="Error Loading Case"
          description="This case could not be displayed. Please refresh the page or contact support if the issue persists."
          type="error"
          showIcon
          closable
          style={{ margin: '12px 0' }}
          onClose={() => this.setState({ hasError: false, error: null })}
        />
      );
    }

    return this.props.children;
  }
}

export default CaseErrorBoundary;

